import React, { useState, useEffect } from 'react';
import { useSearchResults } from '@context/DataContext';
import { getValue } from '@hooks/useLocalStorage';

export const NoSaved = () => {
  const { tabNames, localStorageKey, contentHeadings, resultTab } = useSearchResults();
  const [noResults, setNoResults] = useState(false);

  const checkSet = () => {
    const i = getValue(localStorageKey);
    setNoResults(!i?.length && resultTab === tabNames?.saved);
  };

  useEffect(() => {
    checkSet();
  }, [resultTab]);

  // listen for storage changes and update the count badge value
  window.addEventListener('storage', () => {
    checkSet();
  });

  return noResults ? (
    <article role="alert" className="base-cards__list">
      <div className="base-cards__card base-cards__card--nohover">
        <div className="base-cards__body">Your {contentHeadings[tabNames.saved]} is empty.</div>
      </div>
    </article>
  ) : (
    <></>
  );
};
export default NoSaved;
